import { Enums } from '../models/common/enums'

export class EventsNames {

    public static getEventNameByModule(eventCategory: Enums.SimaxEventCategory, moduleName: Enums.SimaxModuleName): string {
        var eventName: string = null
        if (moduleName != Enums.SimaxModuleName.Unknown)
            eventName = Enums.SimaxEventCategory[eventCategory].replace("_MODULE_NAME_", Enums.SimaxModuleName[moduleName].toUpperCase())
        else
            console.log("Cannot find event name for module name: " + Enums.SimaxModuleName[moduleName])

        return eventName
    }

    static WINDOW_RESIZED = 'WINDOW_RESIZED'
    static CLOSE_DETAILS_POPUP = 'CLOSE_DETAILS_POPUP'
    static TAB_SELECTION_CHANGE = 'TAB_SELECTION_CHANGE'
    static ESC_KEY_PRESS = 'ESC_KEY_PRESS'
    static MAP_CENTER = 'event:mapCenter'
    static RESET_MAP_STYLE = 'event:resetMapStyle'
    static DETAILS_ACTIONS_UPDATED = 'event:DetailsActionsUpdated'
    static SHOW_LOADING_INDICATOR = 'showLoadingIndicator'
    static HIDE_LOADING_INDICATOR = 'hideLoadingIndicator'
    static DISABLE_LOADING_INDICATOR = 'disableLoadingIndicator'
    static ENABLE_LOADING_INDICATOR = 'enableLoadingIndicator'
    static ON_LOGGED = 'event:OnLogged'
    static REFRESH_MENU = "event:REFRESH_MENU"
    static OPEN_TARGET = 'event.openTarget'

    //ACTOR
    static ACTOR_OPEN_DETAILS_POPUP = 'ACTOR_OPEN_DETAILS_POPUP'
    static ACTOR_CLOSE_DETAILS_POPUP = 'ACTOR_CLOSE_DETAILS_POPUP'
    static ACTOR_OPEN_CREATE_EDIT_POPUP = 'ACTOR_OPEN_CREATE_EDIT_POPUP'
    static ACTOR_OPEN_BULK_EDIT_POPUP = 'ACTOR_OPEN_BULK_EDIT_POPUP'
    static ACTOR_DELETED = 'ACTOR_DELETED'

    //CONSUMER
    static CONSUMER_OPEN_DETAILS_POPUP = 'CONSUMER_OPEN_DETAILS_POPUP'

    //DEPOSITORY
    static DEPOSITORY_OPEN_DETAILS_POPUP = 'DEPOSITORY_OPEN_DETAILS_POPUP'
    static DEPOSITORY_CLOSE_DETAILS_POPUP = 'DEPOSITORY_CLOSE_DETAILS_POPUP'
    static DEPOSITORY_OPEN_CREATE_EDIT_POPUP = 'DEPOSITORY_OPEN_CREATE_EDIT_POPUP'
    static DEPOSITORY_OPEN_BULK_EDIT_POPUP = 'DEPOSITORY_OPEN_BULK_EDIT_POPUP'
    static DEPOSITORY_DELETED = 'DEPOSITORY_DELETED'
    static DEPOSITORY_UPDATED_CONTENT = 'updateDepositorySourceGrid'

    //GROUPING LOCATION
    static GROUPING_LOCATION_OPEN_DETAILS_POPUP = 'GROUPING_LOCATION_OPEN_DETAILS_POPUP'
    static GROUPING_LOCATION_CLOSE_DETAILS_POPUP = 'GROUPING_LOCATION_CLOSE_DETAILS_POPUP'
    static GROUPING_LOCATION_OPEN_CREATE_EDIT_POPUP = 'GROUPING_LOCATION_OPEN_CREATE_EDIT_POPUP'
    static GROUPING_LOCATION_OPEN_BULK_EDIT_POPUP = 'GROUPING_LOCATION_OPEN_BULK_EDIT_POPUP'
    static GROUPING_LOCATION_DELETED = 'GROUPING_LOCATION_DELETED'
    static GROUPING_LOCATION_UPDATED_CONTENT = 'updateDepositorySourceGrid'

    //OPERATOR GROUP
    static OPERATOR_GROUP_OPEN_DETAILS_POPUP = 'OPERATOR_GROUP_OPEN_DETAILS_POPUP'

    //REPORTS
    static REPORT_OPEN_DETAILS_POPUP = 'REPORT_OPEN_DETAILS_POPUP'
    static REPORT_CLOSE_DETAILS_POPUP = 'REPORT_CLOSE_DETAILS_POPUP'
    static REPORT_OPEN_CREATE_EDIT_POPUP = 'REPORT_OPEN_CREATE_EDIT_POPUP'
    static REPORT_OPEN_BULK_EDIT_POPUP = 'REPORT_OPEN_BULK_EDIT_POPUP'
    static REPORT_DELETED = 'REPORT_DELETED'

    // do usunięcia
    static OPEN_CONTACT_DETAILS_POPUP = 'event:showContactDetailsPopup'
    static CLOSE_CONTACT_DETAILS_POPUP = 'event:hideContactDetailsPopup'
    static OPEN_CONTACT_CREATE_EDIT_POPUP = 'event:openContactCreateEditPopup'
    static CLOSE_CONTACT_CREATE_EDIT_POPUP = 'event:closeContactCreateEditPopup'
    static OPEN_CONTACT_DELETE_CONFIRMATION_POPUP = 'event:openContactDeleteConfirmationPopup'
    static CLOSE_CONTACT_DELETE_CONFIRMATION_POPUP = 'event:closeContactDeleteConfirmationPopup'
    static CONFIRM_CONTACT_DELETE_CONFIRMATION_POPUP = 'event:confirmContactDeleteConfirmationPopup'
    static CONTACT_DELETED = 'event:contactDeleted'


    static REPORT_GENERATE = 'event:openReportGenerate'
    static OPEN_REPORT_STATUS_CHANGE_POPUP = 'event:openReportStatusChangePopup' // usunąć po przerobieniu generowania raportów

    //DEPOSITORY używane w user-details i depository properties, usunąć po przerobieniu
    static OPEN_DEPOSITORY_CREATE_EDIT_POPUP = 'event:openLocationCreateEditPopup'
    static DEPOSITORY_LOCATION_CREATED_EDITED = 'event:depositoryLocationCreatedEdited'

    static OPEN_LOCATION_DETAILS_POPUP = 'LOCATION_OPEN_DETAILS_POPUP'
    static OPEN_LOCATION_DETAILS_POPUP_BY_STRING_OF_PARAMS = 'event:openDetailsLocationPopupByStringOfParams'
    static CLOSE_LOCATION_DETAILS_POPUP = 'event:closeDetailsLocationPopup'
    static LOCATION_SELECTED_GMAP = 'event:locationSelectedGmap'
    static LOCATION_SELECT_INITIALIZED = 'event:locationSelectInitialized'
    static UPDATE_LOCATION = 'event:updateLocation'
    static OPEN_LOCATION_PROBLEMS_CHANGE_POPUP = 'event:openLocationProblemsChangePopup'

    static OPEN_GROUPS_EDIT_POPUP = 'event:openGroupsEditPopup'
    static CLOSE_GROUPS_EDIT_POPUP = 'event:closeGroupsEditPopup'
    static OPEN_MASS_GROUPS_EDIT_POPUP = 'event:openMassGroupsEditPopup'
    static SAVE_GROUPS = 'event:saveGroups'
    static OPEN_GRID_EDIT_POPUP = 'event:openGridEditPopup'
    static SEND_SAVE_PARAMETERS = 'event:sendSaveParameters'
    static OPEN_GRID_ATTACHMENTS_EDIT_POPUP = 'event:openGridAttachmentsEditPopup'

    static OPEN_GRID_INTALLED_DEVICES_EDIT_POPUP: 'event:openGridInstalledDevicesPopup'
    static OPEN_GRID_UNINTALLED_DEVICES_EDIT_POPUP: 'event:openGridUninstalledDevicesPopup'

    static CLOSE_GRID_EDIT_POPUP = 'event:closeGridEditPopup'
    static SHOWING_GRID_EDIT_POPUP = 'event:showingGridEditPopup'
    static CLOSE_GRID_ATTACHMENTS_EDIT_POPUP = 'event:closeGridAttachmentsEditPopup'
    static OPEN_SELECT_BOX_POPUP = 'event:selectBoxPopup'
    static OPEN_SELECT_POPOVER_POPUP = 'event:selectPopoverPopup'
    static OPEN_SELECT_POPOVER_MULTY_SELECTION_POPUP = 'event:openSelectPopoverMultySelectionPopup'
    static OPEN_TEXTAREA_POPUP = 'event:textAreaPopup'
    static CLOSE_TEXTAREA_POPUP = 'event:closeTextAreaPopup'
    static OPEN_DATEBOX_POPUP = 'event:openDateBoxPopup'

    static INITIALIZE_CREATE_EDIT_POPUP = 'INITIALIZE_CREATE_EDIT_POPUP'
    static INITIALIZE_BULK_EDIT_POPUP = 'INITIALIZE_BULK_EDIT_POPUP'
    static OPEN_CREATE_EDIT_POPUP = 'OPEN_CREATE_EDIT_POPUP'
    static CLOSE_CREATE_EDIT_POPUP = 'event:closeCreateEditPopup'
    static SHOW_CREATE_EDIT_POPUP = 'event:showCreateEditPopup'
    static OPEN_IMPORT_POPUP = 'event:openImportPopup'
    static CLOSE_IMPORT_POPUP = 'event:closeImportPopup'
    static OPEN_LOCATION_CREATE_EDIT_POPUP = 'event:openLocationCreateEditPopup'
    static OPEN_LOCATION_CREATE_EDIT_POPUP_BY_STRING_OF_PARAMS = 'event:openLocationCreateEditPopupByStringOfParams'
    static LOCATION_DELETED = 'event:locationDeleted'
    static UPDATE_CHART = 'event:updateChartForLocationPreview'
    static UPDATE_GRID_DETAILS = 'event:updateShortGridDetails'
    static OPEN_SAVE_COLUMN_SETTINGS_POPUP = 'event:openSaveColumnSettingsPopup'
    static CLOSE_SAVE_COLUMN_SETTINGS_POPUP = 'event:closeSaveColumnSettingsPopup'
    static OPEN_LOAD_COLUMN_SETTINGS_POPUP = 'event:openLoadColumnSettingsPopup'
    static CLOSE_LOAD_COLUMN_SETTINGS_POPUP = 'event:closeLoadColumnSettingsPopup'
    static OPEN_LOCATION_CREATE_ISSUES_TASKS_POPUP = 'event:openLocationCreateIssuesTasksPopup'
    static CLOSE_LOCATION_CREATE_ISSUES_TASKS_POPUP = 'event:closeLocationCreateIssuesTasksPopup'
    static MASS_LOCATION_GROUPS_EDIT_SUMBIT = 'event:massLocationGroupsEditSubmit'
    static OPEN_MASS_SEND_CONFIGURATION_PROFILE = 'event:openMassSendConfigurationProfile'

    static REFRESH_MAP_SIZE = 'event:refreshMapSize'
    static CLOSE_MAP = 'event:closeSecondGridsterRow'
    static REFRESH_GRID_SIZE = 'event:refreshGridSize'

    static UPDATE_GRID_BUTTONS = 'event:updateGridButtons'
    static UPDATE_GRID_DATASOURCE = 'event:updateGridDatasource'
    static UPDATE_GRID_COLUMNS = 'event:updateGridColumns'

    //OPEN_COORDINATES_POPUP = 'event:openCoordinatesPopup'
    static UPDATE_COORDINATES_BUTTON_POPUP = 'event:updateCoordinatesButtonPopup'

    // delete popup events
    static OPEN_CONFIRMATION_POPUP = 'event:openConfirmationPopup'
    static CLOSE_CONFIRMATION_POPUP = 'event:closeConfirmationPopup'
    static CONFIRM_DELETION_LOCATION = 'event:confirmDeletionLocation'
    static OPEN_COORDINATES_POPUP = 'event:openCoordinatesPopup'
    static CLOSE_COORDINATES_POPUP = 'event:closeCoordinatesPopup'

    //DEVICES
    static DEVICE_OPEN_DETAILS_POPUP = 'DEVICE_OPEN_DETAILS_POPUP'
    static DEVICE_CLOSE_DETAILS_POPUP = 'DEVICE_CLOSE_DETAILS_POPUP'
    static DEVICE_OPEN_CREATE_EDIT_POPUP = 'DEVICE_OPEN_CREATE_EDIT_POPUP'
    static DEVICE_OPEN_BULK_EDIT_POPUP = 'DEVICE_OPEN_BULK_EDIT_POPUP'
    static DEVICE_DELETED = 'DEVICE_DELETED'

    static OPEN_DEVICES_DETAILS_POPUP = 'event:showDevicesDetailsPopup'
    static OPEN_DEVICES_DETAILS_POPUP_BY_STRING_OF_PARAMS = 'event:showDevicesDetailsPopupByStringOfParams'
    static CLOSE_DEVICES_DETAILS_POPUP = 'event:hideDevicesDetailsPopup'
    static OPEN_DEVICES_CREATE_EDIT_POPUP = 'event:openDevicesCreateEditPopup'
    static OPEN_DEVICES_CREATE_EDIT_POPUP_BY_STRING_OF_PARAMS = 'event:openDevicesCreateEditPopupByStringOfParams'
    static CLOSE_DEVICES_CREATE_EDIT_POPUP = 'event:closeDevicesCreateEditPopup'
    static OPEN_DEVICES_DELETE_CONFIRMATION_POPUP = 'event:openDevicesDeleteConfirmationPopup'
    static CLOSE_DEVICES_DELETE_CONFIRMATION_POPUP = 'event:closeDevicesDeleteConfirmationPopup'
    static CONFIRM_DEVICES_DELETE_CONFIRMATION_POPUP = 'event:confirmDevicesDeleteConfirmationPopup'
    static OPEN_RUN_ACTION_POPUP = 'event:openRunActionPopup'
    static OPEN_DEVICE_CONFIGURATION = 'event:openDeviceConfiguration'
    static UPDATE_CONFIGURATION_PROFILE_FUNCTION_LIST = 'event:updateConfigurationProfileFucntionList'
    static SEND_CONFIGURATION_TO_DEVICE = 'event:sendConfigurationToDevice'
    static RUN_ACTION_DIRECTLY = 'event:runActionDirectly'

    //DEVICECONNECTIONS
    static OPEN_DEVICECONNECTIONS_DETAILS_POPUP = 'event:showDeviceConnectionsDetailsPopus'

    //TASKS
    static OPEN_TASKS_DETAILS_POPUP = 'event:showTasksDetailsPopup'
    static CLOSE_TASKS_DETAILS_POPUP = 'event:hideTasksDetailsPopup'
    static OPEN_TASKS_CREATE_EDIT_POPUP = 'event:openTasksCreateEditPopup'
    static CLOSE_TASKS_CREATE_EDIT_POPUP = 'event:closeTasksCreateEditPopup'
    static OPEN_TASKS_DELETE_CONFIRMATION_POPUP = 'event:openTasksDeleteConfirmationPopup'
    static CLOSE_TASKS_DELETE_CONFIRMATION_POPUP = 'event:closeTasksDeleteConfirmationPopup'
    static CONFIRM_TASKS_DELETE_CONFIRMATION_POPUP = 'event:confirmTasksDeleteConfirmationPopup'
    static DOWNLOAD_TASK_ATTACHMENT = 'event:downloadTaskAttachment'
    static TASK_DELETED = 'event:taskDeleted'
    static OPEN_TASKS_STATUS_CHANGE_POPUP = 'event:openTasksStatusChangePopup'
    static CLOSE_TASKS_STATUS_CHANGE_POPUP = 'event:closeTasksStatusChangePopup'

    //ALARMS
    static REFRESH_ALARMS = "event:refreshAlarms"
    static OPEN_ALARMS_DETAILS_POPUP = 'event:showAlarmsDetailsPopup'
    static CLOSE_ALARMS_DETAILS_POPUP = 'event:hideAlarmsDetailsPopup'
    static OPEN_ALARMS_CREATE_EDIT_POPUP = 'event:openAlarmsCreateEditPopup'
    static CLOSE_ALARMS_CREATE_EDIT_POPUP = 'event:closeAlarmsCreateEditPopup'
    static OPEN_ALARMS_DELETE_CONFIRMATION_POPUP = 'event:openAlarmsDeleteConfirmationPopup'
    static CLOSE_ALARMS_DELETE_CONFIRMATION_POPUP = 'event:closeAlarmsDeleteConfirmationPopup'
    static CONFIRM_ALARMS_DELETE_CONFIRMATION_POPUP = 'event:confirmAlarmsDeleteConfirmationPopup'
    static ALARM_DELETED = 'event:alarmDeleted'
    static ALARM_APPROVED = 'event:alarmApproved'

    //ALARM GROUPS
    static OPEN_ALARM_GROUPS_POPUP = 'event:openAlarmGroupsPopup'
    static OPEN_ALARM_GROUPS_DETAILS_POPUP = 'event:showAlarmGroupsDetailsPopup'
    static CLOSE_ALARM_GROUPS_DETAILS_POPUP = 'event:hideAlarmGroupsDetailsPopup'
    static ALARM_GROUP_DELETED = 'event:alarmGroupDeleted'
    static OPEN_ALARM_GROUPS_CREATE_EDIT_POPUP = 'event:openAlarmGroupsCreateEditPopup'
    static REFRESH_ALARM_GROUPS_GRID = 'event:UpdateAlarmGroupsGrid'
    static ALARM_DEF_GROUP_DELETED = 'event:AlarmDefGroupDeleted'
    static ALARM_GROUPS_UPDATED = 'event:AlarmGroupsUpdated'
    static ALARM_DEF_UPDATED = 'event:AlarmDefUpdated'

    //ISSUE
    static OPEN_ISSUES_DETAILS_POPUP = 'event:showIssuesDetailsPopup'
    static CLOSE_ISSUES_DETAILS_POPUP = 'event:hideIssuesDetailsPopup'
    static OPEN_ISSUES_CREATE_EDIT_POPUP = 'event:openIssuesCreateEditPopup'
    static CLOSE_ISSUES_CREATE_EDIT_POPUP = 'event:closeIssuesCreateEditPopup'
    static OPEN_ISSUES_DELETE_CONFIRMATION_POPUP = 'event:openIssuesDeleteConfirmationPopup'
    static CLOSE_ISSUES_DELETE_CONFIRMATION_POPUP = 'event:closeIssuesDeleteConfirmationPopup'
    static CONFIRM_ISSUES_DELETE_CONFIRMATION_POPUP = 'event:confirmIssuesDeleteConfirmationPopup'
    static DOWNLOAD_ISSUE_ATTACHMENT = 'event:downloadIssueAttachment'
    static ISSUE_DELETED = 'event:issueDeleted'
    static ISSUE_ATTACHMENT_COUNT_CHANGED = 'event:issueAttachmentCountChanged'
    static UPDATE_ISSUE = 'event:updateIssue'

    //METER
    static OPEN_METER_CREATE_EDIT_POPUP = 'event:openMeterCreateEditPopup'
    static OPEN_METER_CREATE_EDIT_POPUP_BY_STRING_OF_PARAMS = 'event:openMeterCreateEditPopupByStringOfParams'
    static OPEN_METER_DETAILS_POPUP = 'event:openMeterDetailsPopup'
    static OPEN_METER_DETAILS_POPUP_BY_STRING_OF_PARAMS = 'event:openMeterDetailsPopupByStringOfParams'
    static CLOSE_METER_DETAILS_POPUP = 'event:closeMeterDetailsPopup'
    static METER_DELETED = 'event:meterDeleted'
    static OPEN_METER_ALARM_GROUPS_EDIT_POPUP = 'event:openMeterAlarmGroupsEditPopup'
    static CLOSE_METER_ALARM_GROUPS_EDIT_POPUP = 'event:closeMeterAlarmGroupsEditPopup'
    static SAVE_METER_ALARM_GROUPS = 'event:saveMeterAlarmGroups'
    static OPEN_METER_DEFINITIONS_EDIT_POPUP = 'event:openMeterDefinitionsEditPopup'
    static OPEN_METER_DEFINITIONS_EDIT_POPUP_BY_STRING_OF_PARAMS = 'event:openMeterDefinitionsEditPopupByStringOfParams'

    //METER DEF GROUPS
    static REFRESH_METER_DEFS_FORM = 'event:refreshMeterDefsForm'
    static DELETE_METER_DEF = 'event:deleteMeterDef'

    //USER
    static OPEN_USER_CREATE_EDIT_POPUP = 'event:openUserCreateEdit'
    static OPEN_USER_DETAILS_POPUP = 'event:openUserDetailsPopup'
    static CLOSE_USER_DETAILS_POPUP = 'event:closeUserDetailsPopup'
    static USER_DELETED = 'event:userDeleted'

    static OPEN_PASSWORD_CHANGE_POPUP = 'event:openPasswordChangePopup'
    static USER_CUSTOM_ACTIVITY_CHANGED = 'event:userCustomActivityChanged'

    // distributors
    static DISTRIBUTOR_OPEN_DETAILS_POPUP = 'DISTRIBUTOR_OPEN_DETAILS_POPUP'
    static DISTRIBUTOR_CLOSE_DETAILS_POPUP = 'DISTRIBUTOR_CLOSE_DETAILS_POPUP'
    static DISTRIBUTOR_OPEN_CREATE_EDIT_POPUP = 'DISTRIBUTOR_OPEN_CREATE_EDIT_POPUP'
    static DISTRIBUTOR_OPEN_BULK_EDIT_POPUP = 'DISTRIBUTOR_OPEN_BULK_EDIT_POPUP'
    static DISTRIBUTOR_CLOSE_CREATE_EDIT_POPUP = 'DISTRIBUTOR_CLOSE_CREATE_EDIT_POPUP'
    static DISTRIBUTOR_OPEN_DELETE_CONFIRMATION_POPUP = 'DISTRIBUTOR_OPEN_DELETE_CONFIRMATION_POPUP'
    static DISTRIBUTOR_CLOSE_DELETE_CONFIRMATION_POPUP = 'DISTRIBUTOR_CLOSE_DELETE_CONFIRMATION_POPUP'
    static DISTRIBUTOR_CONFIRM_DELETE_CONFIRMATION_POPUP = 'DISTRIBUTOR_CONFIRM_DELETE_CONFIRMATION_POPUP'
    static CHANGED_ALLOWED_DISTRIBUTORS = 'CHANGED_ALLOWED_DISTRIBUTORS'
    static DISTRIBUTOR_DELETED = 'DISTRIBUTOR_DELETED'

    static OPENED_POPUP = 'event:incrementPopupCount'
    static CLOSED_POPUP = 'event:decrementPopupCount'

    //READING ROUTES    
    static OPEN_ROUTES_DETAILS_POPUP = 'event:showRoutesDetailsPopup'
    static CLOSE_ROUTES_DETAILS_POPUP = 'event:hideRoutesDetailsPopup'
    static OPEN_ROUTES_CREATE_EDIT_POPUP = 'event:openRoutesCreateEditPopup'
    static CLOSE_ROUTES_CREATE_EDIT_POPUP = 'event:closeRoutesCreateEditPopup'
    static OPEN_ROUTES_DELETE_CONFIRMATION_POPUP = 'event:openRoutesDeleteConfirmationPopup'
    static CLOSE_ROUTES_DELETE_CONFIRMATION_POPUP = 'event:closeRoutesDeleteConfirmationPopup'
    static CONFIRM_ROUTES_DELETE_CONFIRMATION_POPUP = 'event:confirmRoutesDeleteConfirmationPopup'
    static ROUTE_DELETED = 'event:routeDeleted'
    static ROUTE_POINT_DRAG_AND_DROP = 'event:routePointDragAndDrop'
    static UPDATE_ROUTE = 'event:updateRoute'


    //SIM CARDS    
    static SIM_CARD_OPEN_DETAILS_POPUP = 'SIM_CARD_OPEN_DETAILS_POPUP'
    static SIM_CARD_OPEN_CREATE_EDIT_POPUP = 'SIM_CARD_OPEN_CREATE_EDIT_POPUP'
    static SIM_CARD_OPEN_BULK_EDIT_POPUP = 'SIM_CARD_OPEN_BULK_EDIT_POPUP'
    static SIM_CARD_OPEN_DELETE_CONFIRMATION_POPUP = 'SIM_CARD_OPEN_DELETE_CONFIRMATION_POPUP'
    static SIM_CARD_CLOSE_DETAILS_POPUP = 'SIM_CARD_CLOSE_DETAILS_POPUP'
    static SIM_CARD_CLOSE_CREATE_EDIT_POPUP = 'SIM_CARD_CLOSE_CREATE_EDIT_POPUP'
    static SIM_CARD_CLOSE_DELETE_CONFIRMATION_POPUP = 'SIM_CARD_CLOSE_DELETE_CONFIRMATION_POPUP'
    static SIM_CARD_CONFIRM_DELETE_CONFIRMATION_POPUP = 'SIM_CARD_CONFIRM_DELETE_CONFIRMATION_POPUP'
    static SIM_CARD_DELETED = 'SIM_CARD_DELETED'


    //ssrs
    static SSRS_REPORT_GENERATE = 'event:openSsrsReportGenerate';
    static SSRS_REPORT_RELOAD = 'event:openSsrsReportReload';
    static SSRS_FIND_TEXT = 'event:openSsrsFindTextInReport';
    static SSRS_REPORT_EXPORT = 'event:openSsrsReportExport';
    static SSRS_REPORT_PRINT = 'event:openSsrsReportPrint';
    static SSRS_SUBREPORT_GENERATE = 'event:openSsrsSubReportGenerate';

    // actions
    static OPEN_ACTION_CREATE_EDIT_POPUP = 'event:openActionCreateEditPopup'
    static OPEN_ACTION_DETAILS_POPUP = 'event:openActionDetailsPopup'
    static CLOSE_ACTION_DETAILS_POPUP = 'event:closeActionDetailsPopup'
    static ACTION_DELETED = 'event:actionDeleted'
    static SCHEMA_CHANGED = 'event:schemaChanged'
    static ACTION_FILTER_UPDATED = 'event:actionFilterUpdated'
    static SHOW_ACTION_STATUS_POPUP = 'event:showActionStatusPopup'

    static STOP_MEASUREMENTS_LOADING = 'event:stopMeasurementsLoading'

    static THEME_CHANGE = 'event:themeChange'
    static RTL_STATUS_CHANGE = 'event:rtlStatusChange'

    // DASHBOARD
    static DASHBOARD_UPDATE = 'event:dashboardUpdate'
    static UPDATE_DASHBOARD_ITEM = 'event:updateDashboardItem'
    static UPDATE_DASHBOARD_ITEM_WS = 'event:updateDashboardItemWS'
    static TILE_COLOR_UPDATE = 'event:tileColorUpdate'

    static CLOSED_IMPORT_POPUP = 'event:closedImportPopup'

    static BEGIN_DASHBOARD_EDIT = 'event:beginDashboardEdit'

    static DASHBOART_GRID_ROW_SELECTED = 'event:dashboardGridRowSelected'
    static DASHBOARD_MAP_MARKER_CLICKED = 'event:dashboardMapMarkerClicked'
    static DASHBOARD_SLIDER_SLICKED = 'event:dashboardSliderSlicked'
    static DASHBOARD_UPDATE_MAP_SOURCE = 'event:DASHBOARD_UPDATE_MAP_SOURCE'
    static DASHBOARD_UPDATE_TABLE_SOURCE = 'event:DASHBOARD_UPDATE_TABLE_SOURCE'
    static DASHBOARD_UPDATE_CHART_SOURCE = 'event:DASHBOARD_UPDATE_CHART_SOURCE'
    static DASHBOARD_UPDATE_METER_SOURCE = 'event:DASHBOARD_UPDATE_METER_SOURCE'
    static DASHBOARD_CHART_POINT_CLICKED = 'event:dashboardChartPointClicked'
    static DASHBOARD_MAP_MARKERS_COUNT_CHANGED = 'event:DASHBOARD_MAP_MARKERS_COUNT_CHANGED'
    static DASHBOARD_MAP_RESET_FILTER = 'event:DASHBOARD_MAP_RESET_FILTER'
    static DASHBOARD_TILE_CLICKED = 'event:DASHBOARD_TILE_CLICKED'
    static DASHBOARD_TILE_GRIDSTER_EDIT = 'event:DASHBOARD_TILE_GRIDSTER_EDIT'
    static DASHBOARD_OPEN_CREATE_EDIT_POPUP = 'event:OpenDashboardCreateEditPopup'

    //gridColumnSettings
    static LOAD_COLUMN_SETTINGS = 'event:loadColumnSettings'
    static SHOW_SAVE_COLUMN_SETTINGS = 'event:showSaveColumnSettings'
    //gridVisibility
    static SHOW_GRID = 'event:showGrid'
    static HIDE_GRID = 'event:hideGrid'

    static FILTERS_UPDATED = 'event:filtersUpdated'
    static FILTERS_UPDATE_CANCEL = 'event:filtersUpdateCancel'
    static FILTERS_INITIALIZED = 'event:filtersInitialized'
    static DISABLE_CANCEL_BUTTON = 'event:disableCancelButton'

    static UPDATE_DEFINITION_GROUPS = 'event:updateDefGroups'
    static OPEN_INFO_POPUP_POPUP = 'event:openInfoPopup'
    static HIDE_BUTTONS_LIST_POPOVER = 'event:hideButtonsListPopover'

    static SERVER_EXCEPTION_OCCURED = 'event:serverExceptionOccured'
    //gridBulkEdit
    static OPEN_BULK_EDIT_POPUP = 'OPEN_BULK_EDIT_POPUP'
    static BULK_EDIT_GRID_UPDATE = 'event:bulkEditGridUpdate'

    static FILTERS_CLEARED = 'event:filtersCleared'
    static FILTERS_CREARED_REDIRECT = 'event:filtersClearedRedirect'

    static CHANGE_FROM_TO_DATE = 'event:changeFromToDate'
    static CHANGE_ACCEPTED_EXTENSIONS = 'event:changeAcceptedExtensions'

    static OPEN_DETAILS_OR_MODULE = 'event:openDetailsOrModule'
    static VALUE_FROM_GRID_SELECT_ADDED = 'event:ValueFromGridSelectAdded'

    static REFRESH_ACTION_FILTERS_POPOVER_POSITION = 'event:refreshActionFiltersPopoverPosition'

    //servicemans
    static OPEN_SERVICEMANS_SELECT_POPUP = 'event:openServicemensSelectPopup'
    static REFRESH_SERVICEMANS_SELECTION = 'event.refreshServicemansSelection'

    //location connect meter/device
    static CONNECT_TO_LOCATION = 'event:connectToLocation'

    static OPEN_DEPOSITORY_REWAREHOUSING = 'event:openDepositoryRewarehousing'

    // events for updates
    static UPDATE_SCHEMAS = 'event:updateSchemas'
    static UPDATE_METERS = 'event:updateMeters'

    // #region kingspan dedicated form
    static OPEN_KINGSPAN_CREATE_EDIT_POPUP = 'OPEN_KINGSPAN_CREATE_EDIT_POPUP'
    static SHOW_KINGSPAN_CREATE_EDIT_POPUP = 'SHOW_KINGSPAN_CREATE_EDIT_POPUP'
    static OPEN_CREATE_EDIT_POPUP_KINGSPAN = 'OPEN_CREATE_EDIT_POPUP_KINGSPAN'
    static SUBMIT_LOCATION_CONFIGURATION_KINGSPAN = 'event:submitLocationConfigurationKingspan'
    // #endregion

    // #region pec-gliwice dedicated form
    static OPEN_CREATE_EDIT_POPUP_DATA_TYPE_GROUP_PEC_GLIWICE = 'OPEN_CREATE_EDIT_POPUP_DATA_TYPE_GROUP_PEC_GLIWICE'
    // #endregion

    //#region  configuration profile create edit custom popup

    static OPEN_CREATE_EDIT_POPUP_CONFIGURATION_PROFILE = 'OPEN_CREATE_EDIT_POPUP_CONFIGURATION_PROFILE'    //#endregion

    //#region supplier
    static UPDATE_SUPPLIER = 'event:UPDATE_SUPPLIER'
    //#endregion
}
